<template>
  <div id="rule">
    <div class="sec-title">
      活动组织：
    </div>
    <p>市教育局、市公安局、市融媒体中心</p>
    <div class="sec-title">参与对象：</div>
    <p>全市幼儿园、中小学生及家长</p>
    <div class="sec-title">活动内容：</div>
    <p>“看视频+问答”，在掌上温岭App开展反诈专题系列微课学习，看视频学习掌握反诈知识，并回答提问巩固知识。</p>
    <div class="sec-title">激励机制：</div>
    <p>（1）活动期间每日登录视频活动页+2分，每日限加一次；</p>
    <p>（2）视频将不定期分批上线，每个视频上限得10分。完整观看一个视频+5分（遇视频中途退出或因程序其他原因未完整观看可重新进行观看），视频观看后答对问题+5分（答错不扣分，如想重新回答可重新观看视频直至回答正确）。活动结束后视频可反复观看但不计分。</p>
    <p>（3）凭积分可以在“兑换”页换取好礼。（暂未开放，开放前另行通知，请及时关注掌上温岭APP推文）</p>
    
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
#rule {
  background-image: url(https://i.tmuyun.com/webpic/W0202306/W020230628/W020230628712852093505.png);
  background-size: 100%;
  background-repeat: no-repeat;
  height: 540px;
  border-radius: 10px;
  color: #000;
  padding: 70px 40px;
  .sec-title{
    font-weight: bold;
  }
  p {
    text-indent: 2em;
    padding: 0;
    margin: 5px;
    font-size: 14px;
  }
}
</style>
